(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Feedback', Feedback);

    Feedback.$inject = ['$resource', 'DateUtils'];

    function Feedback ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/feedbacks/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                },
                isArray: true
            },
            "resolve":{
                method:"GET",
                params:{
                    path:"resolve"
                },
                isArray: false
            },
            "unresolved":{
                method:"POST",
                params:{
                    path:"unresolved"
                },
                isArray: false
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.submitTime = DateUtils.convertDateTimeFromServer(data.submitTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
